import type { ComputerViewModelExtended } from './computer-view-model-extended';

export function computerIsInNetworkWithServer(c: { computersInSameNetwork: ComputerViewModelExtended[] }): boolean {
  const items = c.computersInSameNetwork.filter(function (item) {
    return item.type === 'Server';
  });
  return items.length > 0;
}
